<template>
  <div class="s-setting-container">
    <div class="main-header">
      <div>Billing Address</div>
      <div v-if="adminRole === 'admin'">
        <button
          class="address-icn-btn"
          @click="toggleActionModal(true, 'edit-address', {})"
        >
          <v-icon
            color="#4979FF"
            dark
            medium
          >
            mdi-plus
          </v-icon>
          Add new
        </button>
      </div>
    </div>
    <!-- <ShippingModal
      :show="showModal"
      :view="modalView"
      :toggle="toggleActionModal"
      :address="address"
      :states="states"
      :update="update"
    />
     -->
    <BillingAddress
      :billingAddresses="billingAddresses"
      :editAddress="(address) => toggleActionModal(true, 'edit-address', address)"
      :deleteAddress="(address) => toggleActionModal(true, 'delete-address', address)"
    />
    <AddressModal
      type="BILLING"
      :show="showModal"
      :view="modalView"
      :toggle="toggleActionModal"
      :address="address"
      :states="states"
      :update="update"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '../../../mixins/partnerSettingsMixin';
import BillingAddress from '../../partnerSettings/BillingAddress.vue';
import AddressModal from './shippingModal/AddressModal.vue';

export default {
  name: 'BillingAddressSection',
  components: {
    BillingAddress,
    AddressModal,
  },
  mixins: [partnerSettingsMixin],
  props: {
    billingAddresses: Array,
    update: Function,
    states: Array,
  },
  data() {
    return {
      address: {},
      showModal: false,
      modalView: '',
    };
  },
  methods: {
    handleChange(field, value) {
      if (field === 'address') {
        Object.keys(value).forEach((k) => {
          if (this[k] !== undefined) {
            this[k] = value[k];
          }
        });
      } else {
        this[field] = value;
      }
    },
    toggleActionModal(show, view, address) {
      this.showModal = show;
      if (show) {
        this.modalView = view;
        this.address = address;
      } else {
        this.address = {};
      }
    },
  },
};
</script>
